import { Box, Paper, Stack, Switch, Typography } from "@mui/material"

export function FlagRow({ label, description, checked, onChange, disabled }) {
    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1">{label}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {description}
                    </Typography>
                </Box>
                <Switch checked={checked} onChange={onChange} disabled={disabled} />
            </Stack>
        </Paper>
    )
}
